import { render, staticRenderFns } from "./EmailTemplateTags.vue?vue&type=template&id=0462af18&scoped=true&"
import script from "./EmailTemplateTags.vue?vue&type=script&lang=ts&"
export * from "./EmailTemplateTags.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTemplateTags.vue?vue&type=style&index=0&id=0462af18&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0462af18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChipGroup,VIcon})
